<div class="back-icon" (click)="goBack()" title="Go back">
  <ion-icon name="arrow-back-circle-outline"></ion-icon>
</div>
